import APIS from "../../constant/Endpoint";
import ComboboxInput from "../Reusable/ComboboxInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const BranchInvoiceForm = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <>
      <div className={tw`w-64`}>
        <ComboboxInput
          url={APIS.BRANCH}
          queryKey={"branch"}
          register={register("pickup_branch", {
            required: "Branch Name is required",
          })}
          errors={errors?.pickup_branch}
          name={"pickup_branch"}
          label={" Branch Name"}
          setValue={setValue}
          placeholder={"Select Branch Name"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
    </>
  );
};

export default BranchInvoiceForm;
